/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summary_Share_FailedInputs */

const en_summary_share_failed = /** @type {(inputs: Summary_Share_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not share the summary. Please try again.`)
};

const es_summary_share_failed = /** @type {(inputs: Summary_Share_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo compartir el resumen. Inténtalo de nuevo.`)
};

/**
* | output |
* | --- |
* | "Could not share the summary. Please try again." |
*
* @param {Summary_Share_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const summary_share_failed = /** @type {((inputs?: Summary_Share_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summary_Share_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_summary_share_failed(inputs)
	return en_summary_share_failed(inputs)
});